import { MapItemSUP } from "@/types/search";
import { PropertyDetailsCarousel } from "./carousel";
import { PreferenceCarousel } from "./preference-carousel";

interface PropertyOverlayContentProps {
	sups: MapItemSUP[];
	onToggleFavorite?: (property: MapItemSUP) => void;
	onShortlist?: (property: MapItemSUP) => void;
	isForPreference?: boolean;
	projectName?: string;
}

export function PropertyOverlayContent({
	sups,
	onToggleFavorite,
	onShortlist,
	isForPreference = false,
	projectName,
}: PropertyOverlayContentProps) {
	// Show error state if no SUPs provided
	if (!sups || sups.length === 0) {
		return (
			<div className="flex items-center justify-center h-64">
				<div className="text-gray-500">No properties available</div>
			</div>
		);
	}

	// Use different carousel components based on context
	if (isForPreference) {
		return (
			<PreferenceCarousel
				supIds={sups.map(sup => sup._id)}
				projectName={projectName}
				onToggleFavorite={onToggleFavorite}
				onShortlist={onShortlist}
				className="border-0 shadow-none rounded-none"
			/>
		);
	}

	// Use the full-featured carousel for manual search
	return (
		<PropertyDetailsCarousel
			supIds={sups.map(sup => sup._id)}
			projectName={projectName}
			onToggleFavorite={onToggleFavorite}
			onShortlist={onShortlist}
			className="border-0 shadow-none rounded-none"
			isForPreference={false}
		/>
	);
}
